import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=126276b9&scoped=true&"
import script from "./StepIndicator.vue?vue&type=script&lang=js&"
export * from "./StepIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=126276b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126276b9",
  null
  
)

export default component.exports